'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.8.1@rc-trigger/lib/index.js
 ** module id = 37
 ** module chunks = 0
 **/